<div id="cutomer-eligibility-screen" *ngIf= "showauth">
    <div class="row no-gutters">
        <div class="col-lg-4">
            <app-progress-tracker></app-progress-tracker>
        </div>
        <div class="col-lg-8" id="form-component-section">
            <app-utf-auth-landing-page></app-utf-auth-landing-page>
        </div>
    </div>
</div>